import styled from 'styled-components';
import Label from '../../../element/ui/core/label';

const StyledSidebarPanelButton = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
  min-height: 40px;
  margin: 0;
  padding: 8px 10px;

  &,
  * {
    cursor: pointer;
  }

  /* Tool icons only — not nested controls (e.g. font select chevron) */
  > svg {
    display: block;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  &.respark_sidebar-panel-row-btn--disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;

    &,
    * {
      cursor: not-allowed;
    }
  }
`;

const StyledSidebarPanelButtonLabel = styled(Label)`
  margin: 0;
  font-family: Poppins, system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.2px;
  text-align: left;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: inherit;
`;

export { StyledSidebarPanelButton, StyledSidebarPanelButtonLabel };
